<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_4" title="Copyright"></h2>
<p class="small"><em>InterVarsity Press<br/>
  P.O. Box 1400,<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web:</em> <a href="http://www.ivpress.com" target="_blank"><span class="hyperlinks">www.ivpress.com</span></a><br/>
<em>Email:</em> <a href="mailto:email%40ivpress.com?subject="><span class="hyperlinks">email@ivpress.com</span></a></p>
<p class="small"><em>©2013 by</em> <em>Edward Gilbreath</em></p>
<p class="small"><em>All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</em></p>
<p class="small"><em>InterVarsity Press</em><em>®</em> <em>is the book-publishing division of InterVarsity Christian Fellowship/USA</em><em>®</em><em>, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at</em> <a href="http://www.intervarsity.org" target="_blank"><span class="hyperlinks">www.intervarsity.org</span></a><em>.</em></p>
<p class="small"><em>While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.</em></p>
<p class="small"><em>Quotes by Martin Luther King Jr. reprinted by arrangement with The Heirs to the Estate of Martin Luther King Jr., c/o Writers House as agent for the proprietor New York, NY. Copyright: 1962, 1963, 1964, 1965, Martin Luther King Jr. Copyright renewed 1986, 1991 Heirs of Martin Luther King Jr.</em></p>
<p class="small"><em>Design: Cindy Kiple</em></p>
<p class="small"><em>Images:<br/>
  The March on Birmingham: The Granger Collection, NYC/ All rights reserved.<br/>
  Dr. Martin Luther King Jr.: The Granger Collection, NYC/ All rights reserved.<br/>
  Photo of Edward Gilbreath: Phil Marcelo</em></p>
<p class="small"><em>ISBN 978-0-8308-8445-2 (digital)<br/></em><em>ISBN 978-0-8308-3769-4 (print)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?51ae7028